/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentModels } from '../../models/document-models';

export interface DocumentDetail$Params {
  PatientId?: string | null;
  PracticeId?: string | null;
  Id?: string | null;
  fileFormat?: string | null;
  DBIndic?: string | null;
  DocumentType?: string | null;
  VisitDate?: string | null;
  Description?: string | null;
  Location?: string | null;
  AddWaterMarkIfEnabled?: boolean;
}

export function documentDetail(http: HttpClient, rootUrl: string, params?: DocumentDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentModels>> {
  const rb = new RequestBuilder(rootUrl, documentDetail.PATH, 'get');
  if (params) {
    rb.query('PatientId', params.PatientId, {});
    rb.query('PracticeId', params.PracticeId, {});
    rb.query('Id', params.Id, {});
    rb.query('fileFormat', params.fileFormat, {});
    rb.query('DBIndic', params.DBIndic, {});
    rb.query('DocumentType', params.DocumentType, {});
    rb.query('VisitDate', params.VisitDate, {});
    rb.query('Description', params.Description, {});
    rb.query('Location', params.Location, {});
    rb.query('AddWaterMarkIfEnabled', params.AddWaterMarkIfEnabled, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentModels>;
    })
  );
}

documentDetail.PATH = '/document/details';
